"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextObject = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _text = require("../../../../styles/2_commonComponentStyles/text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledTextObject = _styledComponents.default.div.withConfig({
  displayName: "BaseTextObjectstyles__StyledTextObject",
  componentId: "sc-1t8bq7o-0"
})(["font-weight:", ";padding:", ";text-align:", ";&,& *{color:", ";", " ", " ", "}"], function (props) {
  return props.theme.primaryNormal;
}, function (props) {
  return props.zeroPadding ? 0 : "".concat(props.theme.standardPadding, " 0");
}, function (props) {
  return props.alignment ? props.alignment : 'inherit';
}, function (props) {
  return (0, _text.getForegroundColor)(props);
}, function (props) {
  return props.bold && _text.bold;
}, function (props) {
  return props.italic && _text.italic;
}, function (props) {
  return props.underline && _text.underline;
});

exports.StyledTextObject = StyledTextObject;